import React, { useState, useEffect } from 'react'
import Login, { LoginForm } from 'pages/auth/Login'
import { useMutation } from 'react-query'

import FullScreenLoading from 'components/FullScreenLoading'
import { login, logout } from 'services/auth'

const AuthContext = React.createContext<{
  isAuthenticated: boolean
  logout: () => void
}>({
  isAuthenticated: false,
  logout: () => undefined,
})

const AuthProvider: React.FC<Record<string, unknown>> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const loginMutation = useMutation(login)
  const logoutMutation = useMutation(logout)

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('IS_AUTHENTICATED')
    if (isAuthenticated) {
      setIsAuthenticated(true)
    }
  }, [])

  const onLogin = async (credentials: LoginForm) => {
    await loginMutation.mutateAsync(credentials)
    setIsAuthenticated(true)
    localStorage.setItem('IS_AUTHENTICATED', 'true')
  }

  const onLogout = async () => {
    await logoutMutation.mutateAsync()
    setIsAuthenticated(false)
    localStorage.removeItem('IS_AUTHENTICATED')
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        logout: onLogout,
      }}
    >
      {isAuthenticated ? (
        children
      ) : (
        <Login login={onLogin} loading={loginMutation.isLoading} />
      )}
    </AuthContext.Provider>
  )
}

const { Consumer } = AuthContext

export { AuthProvider, Consumer as AuthConsumer }

export default AuthContext
